import { NOOP_LOGGER, SystemEvent, SystemEventLevel } from 'bernie-logger';

export const CHANGE_FLIGHT_DIALOG_VIEWED = 'change_flight_dialog_viewed';

export const hasSessionStorageIdentifier = (identifier: string): boolean => {
  try {
    return typeof window !== 'undefined' && Boolean(window.sessionStorage?.getItem(identifier));
  } catch (error) {
    NOOP_LOGGER.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'SESSION STORAGE ERROR'), error);
  }
};

export const setSessionStorage = (identifier: string): void => {
  try {
    window.sessionStorage.setItem(identifier, 'true');
  } catch (error) {
    NOOP_LOGGER.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'FAILED TO SET SESSION STORAGE'), error);
  }
};
